import Box from '@mui/material/Box';

import { unwrap } from '@/api/envelope';
import { portalActivity, portalActivityActors } from '@/api/generated';
import {
  ActivityTable,
  type ActivityQuery,
  type ActorsQuery,
} from '@/components/activity/ActivityTable';
import { STAFF_ONLY_FIELDS } from '@/components/activity/formatValue';
import { PageHeader } from '@/components/ui/PageHeader';

async function fetchEntries(query: ActivityQuery) {
  const reply = await portalActivity({ query, throwOnError: true });
  const data = unwrap(reply.data);
  return { items: data?.items ?? [], total: data?.pagination?.total ?? 0 };
}

async function fetchActors(query: ActorsQuery) {
  const reply = await portalActivityActors({ query, throwOnError: true });
  return unwrap(reply.data) ?? [];
}

/**
 * The organization's own audit log, as its Super Admin reads it: everything
 * done to the organization, by its own people and by Activist staff.
 *
 * No organization filter and no organization column - the feed is always the
 * organization the Super Admin is working in, and the backend refuses to be
 * told otherwise. Staff's internal billing fields are dropped from every entry
 * before it is shown; see `STAFF_ONLY_FIELDS`.
 */
export function ActivityPage() {
  return (
    <Box data-testid="org-activity-page">
      <PageHeader
        title="Activity"
        description="Every change made to your organization in the portal, and who made it."
      />
      <ActivityTable
        view="portal"
        testId="org-activity"
        fetchEntries={fetchEntries}
        fetchActors={fetchActors}
        hiddenFields={STAFF_ONLY_FIELDS}
        hideStaffNames
      />
    </Box>
  );
}
